import { Component, ElementRef, Inject } from '@angular/core';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subject } from 'rxjs';

@Component({
    selector: 'dialog-resume-mobile-portfolio',
    templateUrl: './dialog-resume-mobile.component.html',
    styleUrls: ['./dialog-resume-mobile.component.scss'],
})

export class DialogResumeMobileComponent extends DialogPanelComponentContent {
    public sendInvestmentSubject: Subject<boolean> = new Subject<boolean>();

    public constructor(
        @Inject(MAT_DIALOG_DATA) public stock,
        private dialogReference: MatDialogRef<DialogResumeMobileComponent>,
        public elementRef: ElementRef,
    ) {
        super(elementRef, true);
    }

    /**
     * Envia o investimento
     */
    public sendInvestment() {
        this.sendInvestmentSubject.next(true);
        setTimeout(() => this.dispose(), 1000);
    }

    /** Finaliza o componente */
    public dispose() {
        super.close(this.dialogReference, null);
    }
}
